/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export const supportSectionGrid = {
  default: "grid-col-2-10 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-1-2"
};

export const supportHeadlineGrid = {
  default: "grid-col-2-10 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-2-3"
};

export const supportSubHeadlineGrid = {
  default: "grid-col-2-10 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-3-4"
};

export const supportAmazonPollyGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12 grid-row-5-6",
  "headline-priority": "grid-col-2-10 grid-row-4-5"
};

export const supportVideoGrid = {
  default: "grid-col-2-14",
  "hero-priority": "grid-col-2-14 grid-row-1-2",
  "headline-priority": "grid-col-2-10 grid-row-5-6"
};

export const supportHorizontalLineGrid = {
  default: "grid-col-2-10"
};

export const supportRelatedStoriesGrid = {
  default: "grid-col-10-14 grid-row-3-9",
  "hero-priority": "grid-col-2-14",
  "headline-priority": "grid-col-10-14 grid-row-1-13"
};

export const supportSocialTagsGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-3-10"
};

export const supportMetypeGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-3-10"
};
